export const EVENTS_SEARCH_PLACEHOLDER = "StageFront ID or Event name";

export const EVENTS_SEARCH_SUPPORTED_INPUTS = "StageFront Event ID, event name, venue and headliner";

const ECHOED_SEARCH_VALUE_MAX_LENGTH = 80;

const echoSearchValue = (searchValue: string): string =>
	searchValue.length > ECHOED_SEARCH_VALUE_MAX_LENGTH
		? `${searchValue.slice(0, ECHOED_SEARCH_VALUE_MAX_LENGTH)}...`
		: searchValue;

export const buildEventsSearchNoMatchMessage = (searchValue: string): string =>
	`No results for "${echoSearchValue(searchValue)}" with the current filters. This search covers ${EVENTS_SEARCH_SUPPORTED_INPUTS}. ` +
	"A Marketplace Event ID is not searchable on this screen, so an empty result here does not mean the event is missing from EMT. " +
	"Search by Marketplace Event ID from the Map modal or the PO Mapping page.";
